import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import downloadFileHandler from "helper/DownloadFile";

const CompanyDetailsView = ({
  companyData = {},
  memberStatus = {},
  acceptMemberInviteHandler = () => {},
  isAccepting = false,
}) => {
  const { t } = useTranslation();

  // Helper to join labels from array of objects
  const joinLabels = (arr) =>
    Array.isArray(arr) ? arr.map((item) => item.label).join(", ") : "";

  return (
    <div className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
      {/* title */}
      <div
        className={`details_info_heading d-flex align-items-center justify-content-between ${
          memberStatus.status === "1" ? "mb-4" : ""
        }`}
      >
        <h2 className="fw-bold mb-0 text-black">{companyData.name}</h2>
        {memberStatus.status === "1" ? null : (
          <button
            onClick={acceptMemberInviteHandler}
            className="btn btn-primary"
            disabled={isAccepting ? true : false}
            style={{
              cursor: isAccepting ? "not-allowed" : "pointer",
            }}
          >
            {t("Accept Invite")}
            {isAccepting && (
              <div
                className="mx-2 spinner-border spinner-border-sm"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </button>
        )}
      </div>

      {memberStatus.status === "1" ? null : memberStatus.joiningdate ? (
        <div className="d-flex justify-content-end mt-1 mb-4">
          <p className="fs-md mb-0 text-black">
            {t("Invitation sent on")} - {memberStatus.joiningdate}
          </p>
        </div>
      ) : null}

      {/* summary */}
      <div className="descriptiion_bx mb-4">
        <h4 className="fs-sm mb-2 fw-semibold">{t("Summary")}</h4>
        <div className="details_info_paragraph">
          <p className="mb-4 text-black fs-md">{companyData.summary}</p>
        </div>
      </div>

      {/* description */}
      <div className="descriptiion_bx mb-4">
        <h4 className="fs-sm mb-2 fw-semibold">{t("Description")}</h4>
        <div className="details_info_paragraph">
          <p
            className="mb-4 text-black fs-md"
            dangerouslySetInnerHTML={{ __html: companyData.about }}
          ></p>
        </div>
      </div>

      {/* interests, searching, services */}
      <div className="descriptiion_bx mb-4">
        <div className="mb-2">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Company Interest")}</h4>
          <div className="fs-md text-black">
            {joinLabels(companyData.companyinterest)}
          </div>
        </div>
        <div className="mb-2">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Company Searching")}</h4>
          <div className="fs-md text-black">
            {joinLabels(companyData.companysearching)}
          </div>
        </div>
        <div className="mb-2">
          <h4 className="fs-sm mb-2 fw-semibold">{t("Company Services")}</h4>
          <div className="fs-md text-black">
            {joinLabels(companyData.companyservices)}
          </div>
        </div>
      </div>

      {/* documents */}
      <div className="documents">
        <h4 className="fs-sm mb-2 fw-semibold">{t("Documents")}</h4>
        <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
          {(companyData.documents || []).map((file, index) => {
            return (
              <li
                className="file d-flex gap-3 align-items-center px-3 py-2 border border-gray rounded-3"
                key={index}
              >
                <p className="fw-medium">{file.name}</p>
                <Link to="#" onClick={() => downloadFileHandler(file)}>
                  <span className="d-block material-symbols-outlined">
                    download
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default CompanyDetailsView;
